import { render, staticRenderFns } from "./Theses.vue?vue&type=template&id=25667810&scoped=true"
import script from "./Theses.vue?vue&type=script&lang=js"
export * from "./Theses.vue?vue&type=script&lang=js"
import style0 from "./Theses.vue?vue&type=style&index=0&id=25667810&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25667810",
  null
  
)

export default component.exports